import { axiosInstance } from "./axios";

export const GetKurumListid = async() => {
  return await axiosInstance
    .get("/corporations")
    .then(res =>  res.data[0])
    .catch((err) => console.log("e", err));
};
